import { ContentWithPadding, SidebarWrapper, Body } from './styles'
import { Title } from './Title'

export const SideBar = {
  Body,
  ContentWithPadding,
  Root: SidebarWrapper,
  Title
}
